import type { AlgoliaIndexItem } from '@algoacademy/backend/modules/docs/external-functions/queries/algolia-index-item-type'

const LOCAL_STORAGE_KEY = 'recentSearches'

export function saveRecentSearch(hit: AlgoliaIndexItem) {
  if (globalThis.window === undefined) return

  const existing = JSON.parse(
    globalThis.window.localStorage.getItem(LOCAL_STORAGE_KEY) ?? '[]'
  ) as AlgoliaIndexItem[]

  const filtered = existing.filter(item => item.article.id !== hit.article.id)
  const updated = [hit, ...filtered].slice(0, 3)

  globalThis.window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updated))
}

export function getRecentSearches(): AlgoliaIndexItem[] {
  if (globalThis.window === undefined) return []
  return JSON.parse(
    globalThis.window.localStorage.getItem(LOCAL_STORAGE_KEY) ?? '[]'
  ) as AlgoliaIndexItem[]
}
